import { render, staticRenderFns } from "./LeftHero.vue?vue&type=template&id=62b05da8&scoped=true&"
import script from "./LeftHero.vue?vue&type=script&lang=js&"
export * from "./LeftHero.vue?vue&type=script&lang=js&"
import style0 from "./LeftHero.vue?vue&type=style&index=0&id=62b05da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b05da8",
  null
  
)

export default component.exports